// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__mrGlR","emails":"CreateEditClinics_emails__2qo9J","emailTagLabel":"CreateEditClinics_emailTagLabel__7B4Hh"};